import { render } from "./ProfileMenu.vue?vue&type=template&id=2c7a112f&scoped=true&ts=true"
import script from "./ProfileMenu.vue?vue&type=script&lang=ts"
export * from "./ProfileMenu.vue?vue&type=script&lang=ts"

import "./ProfileMenu.vue?vue&type=style&index=0&id=2c7a112f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c7a112f"]])

export default __exports__